import { pick } from 'lodash';
import { RestaurantOrg } from 'lib/types/global';
import { IntegrationsAction } from './actions';
import { IntegrationsState, UnconnectedOrg } from './types';

export const initialState = {
  integrators: [],
  existingIntegrations: [],
  integrationState: 'view',
  unconnectedOrgs: [],
} as IntegrationsState;

const reducer = (
  state: IntegrationsState = initialState,
  action: IntegrationsAction,
) => {
  switch (action.type) {
    case 'UPDATE_SITES': {
      const unconnectedOrgs = state.unconnectedOrgs.map((org) => {
        const newSites = org.sites.map((site) => {
          const newSite = action.payload.sites.filter(
            (payloadSite) => payloadSite.id === site.id,
          )[0];
          if (newSite) {
            return newSite;
          }
          return site;
        });

        return { ...org, sites: newSites };
      });

      return {
        ...state,
        unconnectedOrgs,
      };
    }

    case 'GET_INTEGRATORS_SUCCESS': {
      return {
        ...state,
        integrators: action.payload.integrators,
      };
    }

    case 'GET_INTEGRATIONS_SUCCESS': {
      let integrationState = state.integrationState;
      const integrations = action.payload.integrations;

      if (integrations.length < 1) {
        integrationState = 'create';
      }

      const unconnectedBranches = action.payload.unconnectedBranches;
      const orgs = action.extra.orgs as RestaurantOrg[];

      const unconnectedOrgs = orgs
        .map((org) => {
          const sites = org.branches
            .filter((branch) => unconnectedBranches.includes(branch.drnId))
            .map((branch) => {
              return {
                ...pick(branch, ['name', 'id', 'drnId']),
                selected: false,
                siteLocationId: '',
              };
            });

          return {
            ...pick(org, ['name', 'id', 'drnId']),
            sites,
          };
        })
        .filter((org) => org.sites.length > 0) as UnconnectedOrg[];

      return {
        ...state,
        unconnectedOrgs,
        integrationState,
        existingIntegrations: integrations,
      };
    }

    case 'SET_INTEGRATION_STATE_SUCCESS': {
      return {
        ...state,
        integrationState: action.payload.integrationState,
      };
    }

    default:
      return state;
  }
};

export default reducer;
